import { Callback } from 'Pages/leadNeo/common'

export * from './leadUtils'

const BYTES_IN_MEGABYTE = 1024 ** 2

export const byteToMegabyte = (bite: number) => Math.floor(bite / BYTES_IN_MEGABYTE)
export const byteToKilobyte = (bite: number) => Math.floor(bite / 1024)

export const hexToRgba = (hex: string, alpha?: number): string => {
	let r = 0
	let g = 0
	let b = 0
	if (hex?.match(/^#[0-9a-f]{6}$/i)) {
		r = parseInt(hex.slice(1, 3), 16)
		g = parseInt(hex.slice(3, 5), 16)
		b = parseInt(hex.slice(5, 7), 16)
	} else if (hex?.match(/^#[0-9a-f]{3}$/i)) {
		r = parseInt(hex.slice(1, 2).repeat(2), 16)
		g = parseInt(hex.slice(2, 3).repeat(2), 16)
		b = parseInt(hex.slice(3, 4).repeat(2), 16)
	}

	if (alpha) {
		return `rgba(${r},${g},${b},${alpha.toFixed(2)})`
	}
	return `rgba(${r},${g},${b},1)`
}

export const getError = (res: Record<string, any>) =>
	String(Object.values(res?.data?.errors[0] ?? {})[0] ?? '')

export const getMaskPhone = (s: string): string => {
	return s?.length >= 12
		? `${s[0]}${s[1]} (${s[2]}${s[3]}${s[4]}) ${s[5]}${s[6]}${s[7]}-${s[8]}${s[9]}-${s[10]}${s[11]}`
		: ''
}

export const getFileNameAndExt = (fullName: string) => {
	const nameToArray = fullName.split('.')
	const ext = nameToArray.pop()

	return {
		fileName: nameToArray.join('.'),
		ext,
	}
}

export const getActualSize = (bite: number) => {
	if (bite < BYTES_IN_MEGABYTE) return `${byteToKilobyte(bite)} КБ`
	return `${byteToMegabyte(bite)} МБ`
}

export const formatDate = (data: number | string) => {
	const date = new Date(data)
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
	}

	return date.toLocaleDateString('ru', options)
}
export const escapingQuotesDocument = (field: string): string =>
	(field ?? '').replace(/(\\+)?"/g, '\\"')

const transform = (obj: Record<string, any>, predicate: Callback) => {
	return Object.keys(obj).reduce((memo, key) => {
		if (predicate(obj[key], key)) {
			memo[key] = obj[key]
		}
		return memo
	}, {})
}

export const omit = (obj: Record<string, any>, items: string[]) =>
	transform(obj, (value, key: string) => !items.includes(key))
